export default class DashboardExchangeBankModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
  }
}
